<template>
  <div class="chart-container">
    <h5 v-if="title" class="chart-title">{{ title }}</h5>
    <div v-if="loading" class="d-flex justify-content-center align-items-center h-100">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Chargement...</span>
      </div>
    </div>
    <div v-else-if="!hasData" class="d-flex justify-content-center align-items-center h-100">
      <div class="text-muted">Aucune donnée disponible</div>
    </div>
    <Bar
      v-else
      :chart-data="safeChartData"
      :chart-options="chartOptions"
    />
  </div>
</template>

<script>
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, LinearScale, CategoryScale)

export default {
  name: 'StackedBarChart',
  components: { Bar },
  props: {
    title: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: () => ({ labels: [], datasets: [] })
    },
    loading: {
      type: Boolean,
      default: false
    },
    chartOptions: {
      type: Object,
      default: () => ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }
                if (context.parsed.y !== null) {
                  label += new Intl.NumberFormat('fr-FR').format(context.parsed.y);
                }
                return label;
              }
            }
          }
        },
        scales: {
          x: {
            stacked: true,
          },
          y: {
            stacked: true
          }
        }
      })
    }
  },
  computed: {
    hasData() {
      return this.chartData && 
             this.chartData.datasets && 
             this.chartData.datasets.length > 0 && 
             this.chartData.labels && 
             this.chartData.labels.length > 0;
    },
    safeChartData() {
      // Ensure we always return a valid chart data structure
      if (!this.hasData) {
        return { labels: [], datasets: [] };
      }
      return this.chartData;
    }
  }
}
</script>

<style scoped>
.chart-container {
  position: relative;
  height: 300px;
  width: 100%;
  padding: 15px;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.chart-title {
  font-size: 1.1rem;
  margin-bottom: 15px;
}
</style>
